const API_STACK = 'analytics/';

export const GET_PROVIDER_VALUES = API_STACK + 'provider/:providerUuid/values';
export const GET_PROVIDER_SERIES = API_STACK + 'provider/:providerUuid/series';
export const GET_PROVIDER_INSIGHTS = API_STACK + 'provider/:providerUuid/insights';
export const GET_PROVIDER_CPC = API_STACK + 'provider/:providerUuid/cpc';
export const GET_LOG_API = API_STACK + 'logs/api/:id';
export const GET_LOG_EVENT = API_STACK + 'logs/event/:id';
